import { APP_CONFIG } from "./appconfig";

// const isLocalhost = false; // window.location.hostname === "localhost";
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://codicent.com/";
export const APP_TEMPLATE = import.meta.env.VITE_APP_TEMPLATE;
export const APP_PREFIX = import.meta.env.VITE_APP_PREFIX;
export const APP_TITLE = import.meta.env.VITE_APP_TITLE;
export const AUTH_REDIRECT_URL =
  window.location.hostname === "localhost"
    ? "https://localhost:5173/"
    : import.meta.env.VITE_AUTH_REDIRECT_URL || new URL(window.location.pathname, window.location.origin).toString();
export const USER_PREFIX = import.meta.env.VITE_USER_PREFIX;
export const APP_ICON_URL = import.meta.env.VITE_APP_ICON_URL;
export const APP_SAVE_TITLE = import.meta.env.VITE_APP_SAVE_TITLE;
export const SHOW_LOGBOOK_BUTTON = import.meta.env.VITE_SHOW_LOGBOOK_BUTTON === "true";
export const HIDE_MENU_BUTTON = import.meta.env.VITE_HIDE_MENU_BUTTON === "true";
export const SHOW_SETTINGS_BUTTON = import.meta.env.VITE_SHOW_SETTINGS_BUTTON === "true";
export const APP_THEME_NAME = import.meta.env.VITE_APP_THEME_NAME;
export const APP_NAME = import.meta.env.VITE_APP_NAME;
export const LOGBOOK_TAGS = import.meta.env.VITE_LOGBOOK_TAGS || "";
export const BUTTON_TAG = import.meta.env.VITE_BUTTON_TAG || "app-button";
export const BUTTON_BACKGROUND_COLOR = import.meta.env.VITE_BUTTON_BACKGROUND_COLOR;
export const BUTTON_TEXT_COLOR = import.meta.env.VITE_BUTTON_TEXT_COLOR;
export const BUTTON_HOVER_COLOR = import.meta.env.VITE_BUTTON_HOVER_COLOR;
export const BUTTON_ACTIVE_COLOR = import.meta.env.VITE_BUTTON_ACTIVE_COLOR;
export const THEME_BRAND_COLORS = import.meta.env.VITE_THEME_BRAND_COLORS;
export const APP_HEADER_ICON_URL = import.meta.env.VITE_APP_HEADER_ICON_URL;
export const ABOUT_TEXT = import.meta.env.VITE_ABOUT_TEXT;
export const APP_SPLASH_URL = import.meta.env.VITE_APP_SPLASH_URL;
export const APP_HEADER_COLOR = import.meta.env.VITE_APP_HEADER_COLOR;
export const APP_HEADER_TEXT_COLOR = import.meta.env.VITE_APP_HEADER_TEXT_COLOR;
export const WELCOME_STATUS_PROMPT = import.meta.env.VITE_WELCOME_STATUS_PROMPT;
export const THEME_WELCOME = import.meta.env.VITE_THEME_WELCOME;
export const APP_SLOGAN = import.meta.env.VITE_APP_SLOGAN;
export const APP_BUTTONS = import.meta.env.VITE_APP_BUTTONS;
export const CHAT_INSTRUCTIONS = APP_CONFIG.CHAT_INSTRUCTIONS;
export const THEME_FONTS = import.meta.env.VITE_THEME_FONTS;
export const HTML_HEAD = import.meta.env.VITE_HTML_HEAD;
export const ENABLE_SLIDE_NAVIGATION = import.meta.env.VITE_ENABLE_SLIDE_NAVIGATION === "true";
export const DEBUG = import.meta.env.VITE_DEBUG === "true";
export const CHAT_USER_BACKGROUND_COLOR = import.meta.env.VITE_CHAT_USER_BACKGROUND_COLOR;
export const CHAT_USER_TEXT_COLOR = import.meta.env.VITE_CHAT_USER_TEXT_COLOR;
export const CHAT_BOT_BACKGROUND_COLOR = import.meta.env.VITE_CHAT_BOT_BACKGROUND_COLOR;
export const CHAT_BOT_TEXT_COLOR = import.meta.env.VITE_CHAT_BOT_TEXT_COLOR;
export const THEME_DARK = import.meta.env.VITE_THEME_DARK === "true";
export const AUTH0_SCOPE = import.meta.env.VITE_AUTH0_SCOPE || "read:current_user offline_access";
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || "auth.codicent.com";
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || "80STzWmmzN3Tgf76HgFRyv54keYmvnaw";
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE || "https://codicent.com/api";
export const AUTH0_PROVIDER_SCOPE =
  import.meta.env.VITE_AUTH0_PROVIDER_SCOPE || "read:current_user update:current_user_metadata openid profile email";
export const APP_LOGO_URL = import.meta.env.VITE_APP_LOGO_URL || "/images/logo512.png";
export const AUTH0_USER_DOMAIN = import.meta.env.VITE_AUTH0_USER_DOMAIN;
export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
export const STRIPE_PRICE_ID = import.meta.env.VITE_STRIPE_PRICE_ID;
export const STRIPE_BILLING_LOGIN = import.meta.env.VITE_STRIPE_BILLING_LOGIN;
export const MODULE_SALES = import.meta.env.VITE_MODULE_SALES === "true";
export const SUBSCRIPTION_NEEDED = import.meta.env.VITE_SUBSCRIPTION_NEEDED === "true";
export const HOME_BACKGROUND_IMAGE_URL = import.meta.env.VITE_HOME_BACKGROUND_IMAGE_URL;
export const MENU_BACKGROUND_IMAGE_URL = import.meta.env.VITE_MENU_BACKGROUND_IMAGE_URL;
export const CHAT_BACKGROUND_IMAGE_URL = import.meta.env.VITE_CHAT_BACKGROUND_IMAGE_URL;
export const COMPOSE_BACKGROUND_IMAGE_URL = import.meta.env.VITE_COMPOSE_BACKGROUND_IMAGE_URL;
export const HIDE_SAVE_BUTTON = import.meta.env.VITE_HIDE_SAVE_BUTTON === "true";
export const HIDE_CHAT_BUTTON = import.meta.env.VITE_HIDE_CHAT_BUTTON === "true";
export const LOGBOOK_COLORS = import.meta.env.VITE_LOGBOOK_COLORS;
export const INDEX_TITLE = import.meta.env.VITE_INDEX_TITLE;
export const SHOW_MICROPHONE_BUTTON = import.meta.env.VITE_SHOW_MICROPHONE_BUTTON === "true";
export const SHOW_VOICE_BUTTON = import.meta.env.VITE_SHOW_VOICE_BUTTON === "true";
export const LOGBOOK_TAG_DEFINITIONS = JSON.parse(import.meta.env.VITE_LOGBOOK_TAG_DEFINITIONS || "{}");
export const MODULE_SNAP = import.meta.env.VITE_MODULE_SNAP === "true";
export const REALTIME_VOICE_API_KEY = import.meta.env.VITE_REALTIME_VOICE_API_KEY || "9013365c13ee4f3dad0016fb0f0c450a";
export const MODULE_VOICE = import.meta.env.VITE_MODULE_VOICE === "true";
export const SHOW_CANVAS_BUTTON = import.meta.env.VITE_SHOW_CANVAS_BUTTON === "true";
export const SHOW_SNAP_BUTTON = import.meta.env.VITE_SHOW_SNAP_BUTTON === "true";
export const PUBLIC_FLOW_CODICENT = import.meta.env.VITE_PUBLIC_FLOW_CODICENT;
export const STRIPE_CUSTOMER_PORTAL = import.meta.env.VITE_STRIPE_CUSTOMER_PORTAL;
export const APP_LOG_CODICENT = import.meta.env.VITE_APP_LOG_CODICENT;
export const APP_LOG_TOKEN = import.meta.env.VITE_APP_LOG_TOKEN;
export const REALTIME_VOICE_INSTRUCTIONS = APP_CONFIG.REALTIME_VOICE_INSTRUCTIONS;
export const REDIRECT_URL = import.meta.env.VITE_REDIRECT_URL;
export const APP_URL = import.meta.env.VITE_APP_URL;
export const DEFAULT_LANGUAGE = import.meta.env.VITE_DEFAULT_LANGUAGE;
export const MODULE_FORMS = import.meta.env.VITE_MODULE_FORMS === "true";
export const HIDE_REGISTER_BUTTON = import.meta.env.VITE_HIDE_REGISTER_BUTTON === "true";
export const ANONYMOUS_TOKEN = import.meta.env.VITE_ANONYMOUS_TOKEN;
export const SHOW_CHAT_PROMPTS = import.meta.env.VITE_SHOW_CHAT_PROMPTS === "true";
export const CHAT_WELCOME = import.meta.env.VITE_CHAT_WELCOME;
export const APP_CHAT_TITLE = import.meta.env.VITE_APP_CHAT_TITLE;
export const APP_CHAT_TEXT_PLACEHOLDER = import.meta.env.VITE_APP_CHAT_TEXT_PLACEHOLDER;
export const BUTTON_BORDER_RADIUS = import.meta.env.VITE_BUTTON_BORDER_RADIUS;
export const APP_SPLASH_TEXT = import.meta.env.VITE_APP_SPLASH_TEXT;
export const APP_FOOTER_COLOR = import.meta.env.VITE_APP_FOOTER_COLOR || APP_HEADER_COLOR;
export const APP_FOOTER_TEXT_COLOR = import.meta.env.VITE_APP_FOOTER_TEXT_COLOR || APP_HEADER_TEXT_COLOR;
export const APP_FOOTER_SELECTED_COLOR = import.meta.env.VITE_APP_FOOTER_SELECTED_COLOR;
export const MESSAGE_BACKGROUND_COLOR = import.meta.env.VITE_MESSAGE_BACKGROUND_COLOR;
export const MESSAGE_HIDE_BAR = import.meta.env.VITE_MESSAGE_HIDE_BAR === "true";
export const COMPOSE_SIMPLE_ATTACH_FILE = import.meta.env.VITE_COMPOSE_SIMPLE_ATTACH_FILE === "true";
export const COMPOSE_HIDE_LOCATION = import.meta.env.VITE_COMPOSE_HIDE_LOCATION === "true";
export const SEND_BUTTON_ROUND_BACKGROUND = import.meta.env.VITE_SEND_BUTTON_ROUND_BACKGROUND === "true";
export const SHOW_HELP_BUTTON = import.meta.env.VITE_SHOW_HELP_BUTTON === "true";
export const APP_MENU_TITLE = import.meta.env.VITE_APP_MENU_TITLE;
export const MODULE_SEARCH = import.meta.env.VITE_MODULE_SEARCH === "true";
export const APP_SEARCH_TITLE = import.meta.env.VITE_APP_SEARCH_TITLE;
export const ANONYMOUS_CODICENT = import.meta.env.VITE_ANONYMOUS_CODICENT;
export const MANIFEST_START_URL = import.meta.env.VITE_MANIFEST_START_URL;
export const MANIFEST_SCOPE = import.meta.env.VITE_MANIFEST_SCOPE;
export const SHOW_SAVE_BUTTON_TEXT = import.meta.env.VITE_SHOW_SAVE_BUTTON_TEXT === "true";
export const SHOW_SEND_BUTTON_TEXT = import.meta.env.VITE_SHOW_SEND_BUTTON_TEXT === "true";
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;
export const MODULE_QR = import.meta.env.VITE_MODULE_QR === "true";
export const AUTO_TRANSLATE = import.meta.env.VITE_AUTO_TRANSLATE === "true";
export const APP_LOGBOOK_TITLE = import.meta.env.VITE_APP_LOGBOOK_TITLE;
export const STRIPE_TRIAL_PERIOD_DAYS = Number(import.meta.env.VITE_STRIPE_TRIAL_PERIOD_DAYS) || 0;
